import axios from "axios";
const token = localStorage.getItem('token');


const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const addProduct = async (productData, imageFile) => {
  const formData = new FormData();
  formData.append("productName", productData.productName);
  formData.append("coin", productData.coin);
  formData.append("description", productData.description);
  formData.append("sport", productData.sport);
  formData.append("productImage", imageFile);

  

  try {
    const response = await axios.post(`${BACKEND}/products/add`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 201) { // Check for success status
      console.log("Product added successfully:", response.data);
      return response.data;
    } else {
      throw new Error("Unexpected response status");
    }
  } catch (error) {
    console.error("Error adding product:", error.response ? error.response.data : error.message);
    throw new Error("Unable to add product");
  }
};



export const updateProduct = async (productData, imageFile) => {
console.log(productData)

  const formData = new FormData();
  formData.append("productName", productData.productName);
  formData.append("coin", productData.coin);
  formData.append("description", productData.description);
  formData.append("sport", productData.sport);
  formData.append("productImage", imageFile);

  
  try {
    const response = await axios.put(
      `${BACKEND}/products/update/${productData._id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data; 
  } catch (error) {
    console.error("Error updating product:", error);
    throw new Error("Unable to update product");
  }
};

export const fetchProducts = async () => {
 
  try {
    const response = await axios.get(`${BACKEND}/products/getAllProducts`,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      }      );
    return response.data;
  } catch (error) {
    throw new Error("Error fetching products");
  }
};

export const deleteProduct = async (productId) => {
  try {
    const response = await axios.delete(`${BACKEND}/products/delete/${productId}`);
    return response.data;  
  } catch (error) {
    console.error("Error deleting product:", error);
    throw new Error("Unable to delete product");
  }
};